<template>
	<ui-root :part="{ type: 'interface'}" :data="{}" :errs="errors">
		<div class="form fd-form fd-root" style="max-width: 640px;">
			<div class="form-head">
				<div class="form-head-left">
					<div class="fd-flow">
						<sym-icon name="pencil-bold" />
						<span class="fd-text">{{env.msg("form.addConsent")}}</span>
					</div>
					<div v-if="errors && errors.length>0">
						<api-error level="SEVERE" :message="errorMessage"></api-error>
					</div>
				</div>
			</div>	
			<div class="form-body">
				<div class="fd-widgets">	
					<div class="fd-widget display-standard">
						<div class="pos-label app-label">
							<sym-icon name="consent" /> {{env.msg("consent.consentType")}}: 
						</div>
						<div class="pos-field app-field">
							<select v-model.number="consent.type" tabindex="150">
							  <option value="0">-</option>
							  <option v-for="item in consentTypeList" :value="item.value">{{item.name}}</option>
							</select>
						</div>
					</div>	
					<div class="app-stacked pos-wide">
						<div class="app-label"><span class="fd-text">{{env.msg("consent.description")}}:</span></div>
						<div class="app-field">
							<textarea v-model="consent.description" rows="2" tabindex="180" class="bx-size width100p textarea" ></textarea>
						</div>
					</div>
				</div>	
			</div>
			<div class="form-foot">
				<div class="form-foot-right">
					<p class="btn-line fd-flow" style="flex-wrap: wrap-reverse;">
						<button class="fbutton" :class="{ working: saving && !consent.value }" style="--button-hue:0"
							@click="consent.value=false; save();" :disabled="!canUseSaveButt"
							tabindex="200">{{env.msg("butt.disagree")}}</button>
						<button class="fbutton" :class="{ working: saving && consent.value }" style="--button-hue:120" 
							@click="consent.value=true; save();" :disabled="!canUseSaveButt"
							tabindex="250">{{env.msg("butt.agree")}}</button>
					</p>
				</div>	
			</div>
		</div>
	</ui-root>
</template>

<script setup lang="ts">

import {onMounted, ref, reactive, computed} from "vue";
import {injectEnv} from "@fd/Environment";
import type {ErrorMap} from "@fd/PartInjectKeys";
import {useRouter} from "vue-router";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import {Consent} from "@t/customer/Consent.ts";
import SymIcon from "@fd/helpers/SymIcon.vue";
import ApiError from "@/fd/helpers/ApiError.vue";
import UiRoot from "@fd/containers/UiRoot.vue";
import {useListStore} from "@/store/ListStore.ts";


const env = injectEnv();
const navStore = useNavigationStore();
const ls = useListStore();
const router = useRouter();

const saving = ref<boolean>(false);
const errors = reactive<ErrorMap>([]);
const consent = reactive<Consent>({type: 0});


const errorMessage = computed(() => {
	let erfMes = env.msg('err.formContainsError');
	if (errors.length>0) {
		erfMes = erfMes+" "+errors[0].message;
	}
	return erfMes;
});

const canUseSaveButt = computed(() => {
	return saving.value===false;
});

const consentTypeList = ls.findList("_cct");


function save(): void {
	//console.log("sending dataResult:"+JSON.stringify(consent));
	let endpoint = "api/consents/bulkconsents";
	document.body.style.cursor = "progress";
	saving.value = true;
	errors.length = 0;
	env.net.fetch(endpoint, "POST", consent)
		.then((response) => {
			if (response.ok) { //errors will be shown at agenda next step
				router.back();
			} else {
				response.json()
					.then((data) => {
						if (Array.isArray(data.problems)) {
							for (let problem of data.problems) {
								console.log("problem:"+JSON.stringify(problem));
								errors.push(problem);
							}
						}		
				})
				.catch((reason) => {
					errors.push({ type:"ERROR", level:"WARNING", html: false, message: reason });	
				});
			}
		})
		.finally(() =>  {
			saving.value = false;
			document.body.style.cursor = "auto";
		});	
}
navStore.defineMenu((mb) => mb.standardMenu());

onMounted(() => {
	navStore.forward(env.msg("selector.createConsent"));
	
});
</script>

<style>

</style>

